// Typelizer digest 080e5167d9625c665643e4fa39a892d2
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /learners/schools/:school_id/workspace */
  show: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/workspace', params, options),
    method: 'get',
  }),
}
